import * as React from 'react';

import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';

const ExploreMegaMenuGridItem = () => {
  return (
    <div className="rc-ExploreMegaMenuGridItem">
      <SimplifiedMegaMenuWrapper useCDSButton />
    </div>
  );
};

export default ExploreMegaMenuGridItem;
